import RegistrationEventItemSelection from './RegistrationEventItemSelection';

export default RegistrationEventItemSelection;
